__turbopack_context__.v({
  "ring": "BatteryRings-module__kStesa__ring",
  "root": "BatteryRings-module__kStesa__root",
});
